(() => {
  const topics = {
    delivery: ['Delivery or tracking', 'Shipping transit time is separate from production time. If you have a tracking link, check its latest update and tell us what you need help with.', 'Include your order number if available, the latest tracking update, and any date you need the prints by.'],
    change: ['Add or change an order', 'This sends a request to our team; it does not change your order. We’ll confirm whether the request is possible and whether any additional payment is needed.', 'Include your order number, the item or artwork, the requested size and quantity, and what you want to add or change.'],
    artwork: ['Artwork or print issue', 'Tell us which artwork or print needs attention and what result you expected.', 'Include the filename or item, size and quantity, and whether you want the background kept or removed. For a received print, describe the issue and your pressing settings if relevant.'],
    deadline: ['Delivery timing before ordering', 'Production time and shipping transit time are separate. Tell us your deadline before ordering so we can review your request.', 'Include the quantity, delivery ZIP code, and the date you need the prints. A requested date is not a confirmed delivery promise.'],
    followup: ['Follow up on a previous request', 'Follow up on a previous conversation or an expected refund, credit, or replacement.', 'Include your order number if available, the date of the previous conversation, and what you are waiting for.'],
    other: ['Something else', '', ''],
  };
  for (const form of document.querySelectorAll('[data-help-topic-form]')) {
    if (form.dataset.helpReady) continue;
    form.dataset.helpReady = 'true';
    const select = form.querySelector('[name="contact[Help topic]"]');
    const intro = form.querySelector('[data-topic-description]');
    const hint = form.querySelector('[data-topic-hint]');
    const attachment = form.querySelector('[data-topic-attachments]');
    const alternate = form.querySelector('[data-topic-email]');
    const extraSuccess = form.querySelector('[data-change-success]');
    const pending = document.createElement('p');
    pending.className = 'arteefy-contact__hint';
    pending.dataset.submitPending = 'true';
    pending.setAttribute('role', 'status');
    pending.hidden = true;
    pending.textContent = 'This is taking longer than expected. The result is not confirmed. Please wait and avoid sending the same request again.';
    form.querySelector('[type="submit"]').before(pending);
    let pendingTimer;
    const generic = [intro.textContent, hint.textContent];
    const reasonForSelection = () => Object.keys(topics).find(key => topics[key][0] === select.value) || '';
    const render = () => {
      const reason = reasonForSelection();
      const topic = topics[reason];
      intro.textContent = topic?.[1] || generic[0];
      hint.textContent = topic?.[2] || generic[1];
      const emailAlternative = reason === 'artwork' || reason === 'change';
      attachment.hidden = emailAlternative;
      alternate.hidden = !emailAlternative;
      if (extraSuccess) extraSuccess.hidden = reason !== 'change';
    };
    // Existing values (including browser history restoration) take precedence over the URL.
    const requested = new URLSearchParams(location.search).get('reason');
    if (!select.value && form.querySelector('.arteefy-contact__status')) {
      try {
        const last = sessionStorage.getItem('arteefy-contact-help-topic');
        if (Object.values(topics).some(topic => topic[0] === last)) select.value = last;
      } catch { /* Storage may be disabled; the native form remains usable. */ }
    }
    if (!select.value && Object.hasOwn(topics, requested)) select.value = topics[requested][0];
    select.addEventListener('change', render);
    window.addEventListener('pageshow', () => {
      clearTimeout(pendingTimer);
      pending.hidden = true;
      form.removeAttribute('aria-busy');
      for (const button of form.querySelectorAll('[type="submit"]')) button.disabled = false;
      render();
    });
    form.addEventListener('submit', event => {
      if (form.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
      if (!form.checkValidity()) return;
      try { sessionStorage.setItem('arteefy-contact-help-topic', select.value); } catch { /* Optional nonpersonal context only. */ }
      form.setAttribute('aria-busy', 'true');
      for (const button of form.querySelectorAll('[type="submit"]')) button.disabled = true;
      // A timeout is an unknown outcome, not a failed submission. Only a returned page resets the lock.
      pendingTimer = setTimeout(() => {
        if (form.getAttribute('aria-busy') === 'true') pending.hidden = false;
      }, 15000);
    });
    render();
  }
})();
